// for graph display
export default {
  downloading: false,
  byteDownloaded: 0,
  totalByte: 0,
}
